import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import RegisterRestaurant from "./pages/RegisterRestaurant";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Booking from "./pages/Booking";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PaymentPage from "./pages/PaymentPage";
import OwnerDashboard from "./pages/OwnerDashboard";
import OwnerSettings from "./pages/OwnerSettings";
import "./App.css";

function OwnerRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center font-semibold" style={{ background: "#FBF6EC", color: "#FF5A36" }}>Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "owner") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <div className="App min-h-screen font-sans" style={{ background: "#FBF6EC", color: "#141210" }}>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registra" element={<RegisterRestaurant />} />
        <Route path="/password-dimenticata" element={<ForgotPassword />} />
        <Route path="/reimposta-password" element={<ResetPassword />} />
        <Route path="/prenota/:restaurantId" element={<Booking />} />
        <Route path="/paga/:token" element={<PaymentPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/dashboard" element={<OwnerRoute><OwnerDashboard /></OwnerRoute>} />
        <Route path="/impostazioni" element={<OwnerRoute><OwnerSettings /></OwnerRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors theme="light" />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
